"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { showSelectCategory: false };
    },
    onInput: function (input) {
        this.setState({
            instructors: input.instructors || [],
            departments: input.departments || [],
            languages: input.languages || [],
            categories: input.categories || [],
            tags: input.tags || [],
            badges: input.badges || [],
            certificates: input.certificates || [],
            forums: input.forums || []
        });
    },
    onAdd: function (type) {
        let payload;
        switch (type) {
        case 'departments':
            payload = {
                targets: ['department'],
                label: 'Search for department to add',
                callback: function (type, formated, raw) {
                    const {departmentId, name, description, poster} = raw;
                    if (this.state.departments.filter(dep => {
                            return dep.departmentId == departmentId;
                        }).length)
                        return;
                    this.emit('update', 'departments', [
                        ...this.state.departments,
                        {
                            departmentId,
                            name,
                            description,
                            poster
                        }
                    ]);
                }.bind(this)
            };
            window.Extensions.run('SmartSearch', payload);
            break;
        case 'certificates':
            payload = {
                targets: [
                    'library',
                    'certificate'
                ],
                label: 'Search for certificate to add',
                callback: function (type, formated, raw) {
                    const {title, poster, reference, assets} = raw, versions = Object.keys(assets);
                    if (this.state.certificates.filter(cert => {
                            return cert.reference == reference;
                        }).length)
                        return;
                    const newCertificate = {
                        title,
                        reference,
                        poster,
                        versions
                    };
                    this.onOpen('certificate', newCertificate, function (issueData) {
                        if (!issueData)
                            return;
                        this.emit('update', 'certificates', [
                            ...this.state.certificates,
                            {
                                ...newCertificate,
                                issueData
                            }
                        ]);
                    }.bind(this));
                }.bind(this)
            };
            window.Extensions.run('SmartSearch', payload);
            break;
        case 'categories':
            this.state.showSelectCategory = true;
            break;
        }
    },
    onApply: function (type, ...args) {
        switch (type) {
        case 'categories':
            const [categoryId, name] = args;
            this.state.showSelectCategory = false;
            if (this.state.categories.filter(each => {
                    return each.categoryId == categoryId;
                }).length)
                return;
            this.emit('update', 'categories', [
                ...this.state.categories,
                {
                    categoryId,
                    name
                }
            ]);
        }
    },
    onRemove: function (type, index) {
        if (![
                'departments',
                'categories',
                'certificates',
                'badges',
                'forums'
            ].includes(type))
            return;
        this.state[type].splice(index, 1);
        this.emit('update', type, this.state[type]);
    },
    onDropdownOff: function (e) {
        const $toggle = $(e.target);
        if ($toggle.hasClass('dropdown-toggler') || $toggle.closest('.dropdown-toggler').length)
            return;
        this.state.showSelectCategory = false;
    },
    onOpen: function (type, dataset, callback) {
        if (typeof callback == 'number') {
            const index = callback;
            callback = function (issueData) {
                this.state.certificates[index].issueData = issueData;
                this.emit('update', 'certificates', this.state.certificates);
            }.bind(this);
        }
        this.emit('open', type, dataset, callback);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Accessories/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Image_template = require("../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Bx_template = require("../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    Row_template = require("../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    SelectCategory_template = require("../SelectCategory.marko"),
    SelectCategory_tag = marko_loadTag(SelectCategory_template),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    WSAdapt_template = require("../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    subscribe_template = require("@marko-tags/subscribe/index.marko"),
    subscribe_tag = marko_loadTag(subscribe_template),
    marko_attrs0 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs1 = {
        "class": "sub-body py-25"
      },
    marko_attrs2 = {
        "class": "list-unstyled users-list m-0 d-flex align-items-center ml-1"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("789e6a"),
    marko_node0 = marko_createElement("br", null, "6", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs4 = {
        "class": "sub-body py-50"
      },
    marko_node1 = marko_createElement("br", null, "20", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs5 = {
        "class": "d-flex align-items-center"
      },
    marko_attrs6 = {
        "class": "position-absolute toggle zindex-1 top-0 right-0 cursor-pointer my-75"
      },
    marko_attrs7 = {
        "class": "col-4 text-center align-middle"
      },
    marko_attrs8 = {
        "class": "theme-bg-lighten d-flex align-items-center justify-content-center rounded cursor-pointer",
        style: "width:40px;height:40px;"
      },
    marko_attrs9 = {
        "class": "sub-header blue-grey-text"
      },
    marko_node2 = marko_createElement("div", {
        "class": "sub-body py-50"
      }, "23", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-inline"
        }, null, null, 3)
        .e("li", {
            "class": "p-25"
          }, null, null, 1)
          .e("span", {
              "class": "theme-bg-fade round px-1 py-50"
            }, null, null, 1)
            .t("English")
        .e("li", {
            "class": "p-25"
          }, null, null, 1)
          .e("span", {
              "class": "theme-bg-fade round px-1 py-50"
            }, null, null, 1)
            .t("Russia")
        .e("li", {
            "class": "p-25"
          }, null, null, 1)
          .e("span", {
              "class": "theme-bg-fade round px-1 py-50"
            }, null, null, 1)
            .t("Chinese"),
    marko_node3 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs10 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs11 = {
        "class": "sub-body py-50"
      },
    marko_attrs12 = {
        "class": "list-inline"
      },
    marko_attrs13 = {
        "class": "chip theme-bg-lighten"
      },
    marko_attrs14 = {
        "class": "chip-body font-small-5"
      },
    marko_attrs15 = {
        "class": "chip-text py-50"
      },
    marko_attrs16 = {
        "class": "chip-closeable theme-bg p-25 m-25"
      },
    marko_attrs17 = {
        "class": "dropdown-toggler p-25"
      },
    marko_attrs18 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs19 = {
        "class": "sub-body py-25"
      },
    marko_attrs20 = {
        "class": "list-inline"
      },
    marko_attrs21 = {
        "class": "p-25"
      },
    marko_attrs22 = {
        "class": "chip chip-success theme-bg-lighten"
      },
    marko_attrs23 = {
        "class": "chip-body font-small-5"
      },
    marko_attrs24 = {
        "class": "chip-text py-25"
      },
    marko_attrs25 = {
        "class": "chip-closeable p-25 m-25"
      },
    marko_attrs26 = {
        "class": "p-25"
      },
    marko_attrs27 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs28 = {
        "class": "sub-body py-25"
      },
    marko_attrs29 = {
        "class": "list-inline"
      },
    marko_node4 = marko_createElement("br", null, "67", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs30 = {
        "class": "p-50 my-50 cursor-pointer align-middle hover-toggle"
      },
    marko_attrs31 = {
        "class": "position-absolute toggle zindex-1 top-0 right-0 cursor-pointer"
      },
    marko_attrs32 = {
        "class": "p-50 my-50 text-center align-middle"
      },
    marko_attrs33 = {
        "class": "theme-bg-lighten d-flex align-items-center justify-content-center rounded cursor-pointer",
        style: "width:60px;height:60px;"
      },
    marko_attrs34 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs35 = {
        "class": "sub-body py-25"
      },
    marko_attrs36 = {
        "class": "list-inline"
      },
    marko_attrs37 = {
        "class": "p-50 my-50 cursor-pointer align-middle hover-toggle"
      },
    marko_attrs38 = {
        "class": "position-absolute toggle zindex-1 top-0 right-0 cursor-pointer"
      },
    marko_attrs39 = {
        "class": "p-50 my-50 text-center align-middle"
      },
    marko_attrs40 = {
        "class": "theme-bg-lighten d-flex align-items-center justify-content-center rounded cursor-pointer",
        style: "width:60px;height:60px;"
      },
    marko_attrs41 = {
        "class": "sub-header blue-grey-text"
      },
    marko_attrs42 = {
        "class": "sub-body py-25"
      },
    marko_attrs43 = {
        "class": "list-unstyled"
      },
    marko_attrs44 = {
        "class": "p-25"
      },
    marko_attrs45 = {
        "class": "btn btn-light btn-sm"
      };

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Instructors(out) {
    if ((Array.isArray(state.instructors) && state.instructors.length) || input.editable) {
      out.be("h6", marko_attrs0, "0", component);

      Locale_tag({
          text: "Instructors"
        }, out, __component, "1");

      out.ee();

      out.be("div", marko_attrs1, "2", component);

      out.be("ul", marko_attrs2, "3", component);

      var $for$0 = 0;

      marko_forOf(state.instructors, function(profile) {
        const name = getFullname( profile )

        var $keyScope$0 = "[" + (($for$0++) + "]");

        out.be("li", {
            title: name,
            "class": "avatar border pull-up"
          }, "4" + $keyScope$0, component);

        Image_tag({
            alt: name,
            src: profile.photo,
            style: "width:40px;height:40px"
          }, out, __component, "5" + $keyScope$0);

        out.ee();
      });

      out.ee();

      out.ee();

      out.n(marko_node0, component);
    }
  }

  function macro_Departments(out) {
    if ((Array.isArray(state.departments) && state.departments.length) || input.editable) {
      out.be("h6", marko_attrs3, "7", component);

      Locale_tag({
          text: "Departments"
        }, out, __component, "8");

      out.ee();

      out.be("div", marko_attrs4, "9", component);

      Row_tag({
          class: "d-flex align-items-center",
          renderBody: function(out) {
            marko_forOf(state.departments, function({ departmentId, name, description, poster }, index) {
              var $keyValue$1 = "@" + index,
                  $keyScope$1 = "[" + ($keyValue$1 + "]");

              out.be("div", {
                  "class": "col-12 my-50 hover-toggle",
                  title: Locale(description)
                }, $keyValue$1, component);

              if (input.editable) {
                out.be("span", marko_attrs6, "11" + $keyScope$1, component, null, 0, {
                    onclick: __component.d("click", "onRemove", false, [
                        "departments",
                        index
                      ])
                  });

                Bx_tag({
                    type: "trash",
                    class: "font-medium-1 p-25 theme-bg-lighten round"
                  }, out, __component, "12" + $keyScope$1);

                out.ee();
              }

              out.be("div", marko_attrs5, "13" + $keyScope$1, component);

              Image_tag({
                  alt: name,
                  src: poster,
                  class: "border rounded",
                  style: "width:40px;margin-right:1.3rem"
                }, out, __component, "14" + $keyScope$1);

              route_link_tag({
                  href: "/department/" + departmentId,
                  class: "font-small-3",
                  renderBody: function(out) {
                    Locale_tag({
                        text: name
                      }, out, __component, "16" + $keyScope$1);
                  }
                }, out, __component, "15" + $keyScope$1);

              out.ee();

              out.ee();
            });

            if (input.editable) {
              out.be("div", marko_attrs7, "17", component);

              out.be("div", marko_attrs8, "18", component, null, 0, {
                  onclick: __component.d("click", "onAdd", false, [
                      "departments"
                    ])
                });

              Bx_tag({
                  type: "plus",
                  class: "bx-sm text-muted"
                }, out, __component, "19");

              out.ee();

              out.ee();
            }
          }
        }, out, __component, "10");

      out.ee();

      out.n(marko_node1, component);
    }
  }

  function macro_Languages(out) {
    if ((Array.isArray(state.languages) && state.languages.length) || input.editable) {
      out.be("h6", marko_attrs9, "21", component);

      Locale_tag({
          text: "Language"
        }, out, __component, "22");

      out.ee();

      out.n(marko_node2, component);

      out.n(marko_node3, component);
    }
  }

  function macro_Categories(out) {
    if ((Array.isArray(state.categories) && state.categories.length) || input.editable) {
      out.be("h6", marko_attrs10, "32", component);

      Locale_tag({
          text: "Categories"
        }, out, __component, "33");

      out.ee();

      out.be("div", marko_attrs11, "34", component);

      out.be("ul", marko_attrs12, "35", component);

      marko_forOf(state.categories, function({ name, description }, index) {
        var $keyValue$2 = "@" + index,
            $keyScope$2 = "[" + ($keyValue$2 + "]");

        out.be("li", {
            "class": "p-25",
            title: Locale(description)
          }, $keyValue$2, component);

        out.be("div", marko_attrs13, "36" + $keyScope$2, component);

        out.be("div", marko_attrs14, "37" + $keyScope$2, component);

        out.e("span", marko_attrs15, "38" + $keyScope$2, component, 1)
          .t(name, component);

        if (input.editable) {
          out.be("div", marko_attrs16, "39" + $keyScope$2, component, null, 0, {
              onclick: __component.d("click", "onRemove", false, [
                  "categories",
                  index
                ])
            });

          Bx_tag({
              type: "x"
            }, out, __component, "40" + $keyScope$2);

          out.ee();
        }

        out.ee();

        out.ee();

        out.ee();
      });

      if (input.editable) {
        out.be("li", marko_attrs17, "41", component, null, 0, {
            onclick: __component.d("click", "onAdd", false, [
                "categories"
              ])
          });

        Bx_tag({
            type: "plus",
            class: "theme-bg-lighten round p-50"
          }, out, __component, "42");

        out.ee();

        if (state.showSelectCategory) {
          SelectCategory_tag({
              add: true,
              decoupled: true
            }, out, __component, "43", [
            [
              "add",
              () => navigate('/categories'),
              false
            ],
            [
              "select",
              "onApply",
              false,
              [
                  "categories"
                ]
            ]
          ]);
        }
      }

      out.ee();

      out.ee();
    }
  }

  function macro_Tags(out) {
    if ((Array.isArray(state.tags) && state.tags.length) || input.editable) {
      out.be("h6", marko_attrs18, "44", component);

      Locale_tag({
          text: "Tags"
        }, out, __component, "45");

      out.ee();

      out.be("div", marko_attrs19, "46", component);

      out.be("ul", marko_attrs20, "47", component);

      var $for$1 = 0;

      marko_forOf(state.tags, function(name, index) {
        var $keyScope$3 = "[" + (($for$1++) + "]");

        out.be("li", marko_attrs21, "48" + $keyScope$3, component);

        out.be("div", marko_attrs22, "49" + $keyScope$3, component);

        out.be("div", marko_attrs23, "50" + $keyScope$3, component);

        out.e("span", marko_attrs24, "51" + $keyScope$3, component, 1)
          .t(name, component);

        if (input.editable) {
          out.be("div", marko_attrs25, "52" + $keyScope$3, component, null, 0, {
              onclick: __component.d("click", "onRemove", false, [
                  "tags",
                  index
                ])
            });

          Bx_tag({
              type: "x"
            }, out, __component, "53" + $keyScope$3);

          out.ee();
        }

        out.ee();

        out.ee();

        out.ee();
      });

      if (input.editable) {
        out.be("li", marko_attrs26, "54", component);

        Bx_tag({
            type: "plus",
            class: "theme-bg-lighten round p-50"
          }, out, __component, "55");

        out.ee();
      }

      out.ee();

      out.ee();
    }
  }

  function macro_Badges(out) {
    if ((Array.isArray(state.badges) && state.badges.length) || input.editable) {
      out.be("h6", marko_attrs27, "56", component);

      Locale_tag({
          text: "Badges"
        }, out, __component, "57");

      out.ee();

      out.be("div", marko_attrs28, "58", component);

      out.be("ul", marko_attrs29, "59", component);

      marko_forOf(state.badges, function(badge, index) {
        const { poster, reference, versions } = badge

        var $keyValue$4 = "@" + index,
            $keyScope$4 = "[" + ($keyValue$4 + "]");

        out.be("li", marko_attrs30, $keyValue$4, component);

        if (input.editable) {
          out.be("span", marko_attrs31, "60" + $keyScope$4, component, null, 0, {
              onclick: __component.d("click", "onRemove", false, [
                  "badges",
                  index
                ])
            });

          Bx_tag({
              type: "trash",
              class: "font-medium-1 p-25 theme-bg-lighten round"
            }, out, __component, "61" + $keyScope$4);

          out.ee();
        }

        out.be("div", null, "62" + $keyScope$4, component, null, 0, {
            onclick: __component.d("click", "onOpen", false, [
                "badge",
                badge,
                index
              ])
          });

        Image_tag({
            alt: reference,
            src: poster,
            class: "rounded",
            style: "width:60px;height:60px",
            title: reference
          }, out, __component, "63" + $keyScope$4);

        out.ee();

        out.ee();
      });

      if (input.editable) {
        out.be("li", marko_attrs32, "64", component);

        out.be("div", marko_attrs33, "65", component, null, 0, {
            onclick: __component.d("click", "onAdd", false, [
                "badges"
              ])
          });

        Bx_tag({
            type: "plus",
            class: "bx-lg text-muted"
          }, out, __component, "66");

        out.ee();

        out.ee();
      }

      out.ee();

      out.ee();

      out.n(marko_node4, component);
    }
  }

  function macro_Certificates(out) {
    if ((Array.isArray(state.certificates) && state.certificates.length) || input.editable) {
      out.be("h6", marko_attrs34, "68", component);

      Locale_tag({
          text: "Certificates"
        }, out, __component, "69");

      out.ee();

      out.be("div", marko_attrs35, "70", component);

      out.be("ul", marko_attrs36, "71", component);

      marko_forOf(state.certificates, function(certificate, index) {
        const { poster, reference, versions } = certificate

        var $keyValue$5 = "@" + index,
            $keyScope$5 = "[" + ($keyValue$5 + "]");

        out.be("li", marko_attrs37, $keyValue$5, component);

        if (input.editable) {
          out.be("span", marko_attrs38, "72" + $keyScope$5, component, null, 0, {
              onclick: __component.d("click", "onRemove", false, [
                  "certificates",
                  index
                ])
            });

          Bx_tag({
              type: "trash",
              class: "font-medium-1 p-25 theme-bg-lighten round"
            }, out, __component, "73" + $keyScope$5);

          out.ee();
        }

        out.be("div", null, "74" + $keyScope$5, component, null, 0, {
            onclick: __component.d("click", "onOpen", false, [
                "certificate",
                certificate,
                index
              ])
          });

        Image_tag({
            alt: reference,
            src: poster,
            class: "rounded",
            style: "min-width:60px;height:60px",
            title: reference
          }, out, __component, "75" + $keyScope$5);

        out.ee();

        out.ee();
      });

      if (input.editable) {
        out.be("li", marko_attrs39, "76", component);

        out.be("div", marko_attrs40, "77", component, null, 0, {
            onclick: __component.d("click", "onAdd", false, [
                "certificates"
              ])
          });

        Bx_tag({
            type: "plus",
            class: "bx-lg text-muted"
          }, out, __component, "78");

        out.ee();

        out.ee();
      }

      out.ee();

      out.ee();
    }
  }

  function macro_Forums(out) {
    if ((Array.isArray(state.forums) && state.forums.length) || input.editable) {
      out.be("h6", marko_attrs41, "79", component);

      Locale_tag({
          text: "Forums"
        }, out, __component, "80");

      out.ee();

      out.be("div", marko_attrs42, "81", component);

      out.be("ul", marko_attrs43, "82", component);

      var $for$2 = 0;

      marko_forOf(state.forums, function(id) {
        var $keyScope$6 = "[" + (($for$2++) + "]");

        out.be("li", marko_attrs44, "83" + $keyScope$6, component);

        route_link_tag({
            href: "/ext/#" + id,
            class: "font-small-2",
            renderBody: function(out) {
              out.t("#");

              out.t(id, component);
            }
          }, out, __component, "84" + $keyScope$6);

        out.ee();
      });

      out.ee();

      if (input.editable) {
        out.be("button", marko_attrs45, "85", component, null, 0, {
            onclick: __component.d("click", "onAdd", false, [
                "forums"
              ])
          });

        Bx_tag({
            type: "plus",
            class: "white-text"
          }, out, __component, "86");

        Locale_tag({
            text: "Add Channel",
            class: "align-middle"
          }, out, __component, "87");

        out.ee();
      }

      out.ee();
    }
  }

  WSAdapt_tag({
      qs: "border-top py-2 mt-4",
      hs: "border-top py-2 mt-4",
      ns: "px-md-2",
      class: "w-100",
      renderBody: function(out) {
        Row_tag({
            renderBody: function(out) {
              WSAdapt_tag({
                  qs: "col-3",
                  hs: "col-4",
                  ns: "col-12",
                  renderBody: function(out) {
                    if (state.instructors.length) {
                      marko_dynamicTag(out, macro_Instructors, null, null, null, null, __component, "95");
                    }

                    marko_dynamicTag(out, macro_Departments, null, null, null, null, __component, "96");

                    if (state.languages.length) {
                      marko_dynamicTag(out, macro_Languages, null, null, null, null, __component, "97");
                    }
                  }
                }, out, __component, "90");

              WSAdapt_tag({
                  qs: "col-3",
                  hs: "col-4",
                  ns: "col-12",
                  renderBody: function(out) {
                    marko_dynamicTag(out, macro_Categories, null, null, null, null, __component, "98");
                  }
                }, out, __component, "91");

              WSAdapt_tag({
                  qs: "col-3",
                  hs: "col-4",
                  ns: "col-12",
                  renderBody: function(out) {
                    if (state.badges.length) {
                      marko_dynamicTag(out, macro_Badges, null, null, null, null, __component, "99");
                    }

                    marko_dynamicTag(out, macro_Certificates, null, null, null, null, __component, "100");
                  }
                }, out, __component, "92");

              WSAdapt_tag({
                  qs: "col-3",
                  hs: "col-4",
                  ns: "col-12",
                  renderBody: function(out) {
                    marko_dynamicTag(out, macro_Forums, null, null, null, null, __component, "101");
                  }
                }, out, __component, "93");
            }
          }, out, __component, "89");

        subscribe_tag({
            to: document,
            __events: [
              "on",
              "click"
            ]
          }, out, __component, "94", [
          [
            "click",
            "onDropdownOff",
            false
          ]
        ]);
      }
    }, out, __component, "88");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
